mutation DeleteAudiences($workspaceId: ID!, $audienceIds: [ID]!) {
  success: deleteAudiences(workspaceId: $workspaceId, audienceIds: $audienceIds)
}
